import { Component, ElementRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EmojiEvent } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { ConfirmationDialogeComponent } from 'src/app/Genric/confirmation-dialoge/confirmation-dialoge.component';
import { TicketMessage, TicketsDetails } from 'src/app/Models/help&support';
import { ChatServiceService } from 'src/app/Services/chat-service.service';
import { ConfirmationServiceService } from 'src/app/Services/confirmation-service.service';
import { CustomToasterServiceService } from 'src/app/Services/custom-toaster-service.service';
import { HelpAndSupportService } from 'src/app/Services/help-and-support.service';

@Component({
  selector: 'app-helpsupport',
  templateUrl: './helpsupport.component.html',
  styleUrls: ['./helpsupport.component.css'],
})
export class HelpsupportComponent {

  MessageToSend: string = '';
  CountTotalTickets: number = 0
  CountOpenTickets: number = 0
  CountClosedTickets: number = 0
  PageNumber: number = 1
  overviewFilter: string = '';
  PageSize: number = 10
  totalTicketPAges: number = 0
  SelectedFilter: string = '';
  AllTicketsDetails: TicketsDetails[] = []
  TotalTicketsCount: number = 0
  searchText: string = '';
  ShowClosedTickets: boolean = false;
  private searchAllSubject = new Subject<string>();
  adminid: number = 0;  
  TicketChatHistory: TicketMessage[] = [];
  AdminProfilePhotoUrl: string = '';
  TouristProfilePhotoUrl: string = '';

  SelectedTicket: TicketsDetails | null = null;

  constructor(private helpsupportservice: HelpAndSupportService,
     private confirmDialogService: ConfirmationServiceService,
     private toaster:CustomToasterServiceService,
    private chatservice:ChatServiceService) { }
  @ViewChild('chatContainer') private chatContainer!: ElementRef;

  ngOnInit() {
     
const storedData = sessionStorage.getItem('userData');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
 
      this.adminid = parsedData.userId;
      this.AdminProfilePhotoUrl = parsedData.profilePhotoUrl 
    
    }

    this.getTicketsOverview()
    this.searchAllSubject.pipe(
      debounceTime(400),          
      distinctUntilChanged()        
    ).subscribe(searchText => {
      this.searchText = searchText;
      this.getAllOpenTickets();
    });
  }

  onSearchChange(search: string) {
     
    this.searchAllSubject.next(search);

  }


  ngAfterViewInit() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
     
    try {
          setTimeout(() => {
    
      if (this.chatContainer) {

        this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
      }
    }, 100); 

     
    } catch (err) {
   
    }
  }


  getTicketsOverview() {
     
    this.helpsupportservice.getBookingOverview(this.overviewFilter).subscribe((res) => {

      this.CountTotalTickets = res.totalTickets
      this.CountOpenTickets = res.openTickets
      this.CountClosedTickets = res.closedTickets

    })
  }

  overview: boolean = true
  opentickit: boolean = false
  closedtickit: boolean = false
  opentickitnumber: boolean = false
  closetickitnumber: boolean = false
  dropdown: boolean = true


  showoverview() {
   this.getTicketsOverview()
    this.overview = true
    this.opentickit = false
    this.closedtickit = false
    this.closetickitnumber = false
    this.opentickitnumber = false
  }
  showopentickit() {
    this.ShowClosedTickets = false
    this.PageNumber = 1;
    this.PageSize = 10;
    this.searchText = '';
    this.SelectedFilter = '';
    this.getAllOpenTickets()



    this.overview = false
    this.opentickit = true
    this.closedtickit = false
    this.opentickitnumber = true
    this.closetickitnumber = false
    this.dropdown = false
  }

  showclosedtickit() {
    this.ShowClosedTickets = true
    this.PageNumber = 1;
    this.PageSize = 10;
    this.searchText = '';
    this.SelectedFilter = '';
    this.getAllOpenTickets()

    this.overview = false
    this.opentickit = false
    this.closedtickit = true
    this.opentickitnumber = false
    this.closetickitnumber = true
    this.dropdown = false
  }

  getAllOpenTickets() {
     
    this.helpsupportservice.getAllOpenTickets(this.searchText, this.SelectedFilter, this.ShowClosedTickets, this.PageNumber, this.PageSize).subscribe((res) => {
      this.AllTicketsDetails = res.items;
      this.TotalTicketsCount = res.totalCount;
      this.totalTicketPAges = Math.ceil(this.TotalTicketsCount / this.PageSize);

    })
  }
  goToPages(page: number) {
    if (page < 1 || page > this.totalTicketPAges) {
      return;
    }
    this.PageNumber = page;
    this.getAllOpenTickets();
  }

  onSizeChanges(size: number) {
    this.PageSize = size;
    this.PageNumber = 1;
    this.getAllOpenTickets();
  }

  OnOverviewFilterChange() {
     

    this.getTicketsOverview();
 
  }

  onStatusChange() {
    this.SelectedFilter = this.SelectedFilter
    this.PageNumber = 1

    this.getAllOpenTickets();
  }



  closeticket(ticketId: number) {

    this.confirmDialogService.openConfirmDialog(`Great! Looks like this issue has been resolved.
Are you sure do you want to close the Ticket <strong>#${ticketId}</strong> `, () => {
      this.helpsupportservice.closeTicket(ticketId, this.adminid).subscribe((res) => {
        this.getAllOpenTickets();
        this.toaster.success('Ticket closed successfully');

      }, (error) => {
        console.error('Error closing ticket:', error);
      });


    }, '/assets/confirmation-msg/CloseTicket.png');


  }
closeChatCanvas() {
    this.SelectedTicket = null; 
    this.TicketChatHistory = [];
    this.MessageToSend = '';  
    this.showEmojiPicker = false;
  }
 

  deleteTicket(ticketId: number) {
    this.confirmDialogService.openConfirmDialog(` Are you sure you want to permanently delete this Ticket <strong>#${ticketId}</strong> 
This action cannot be undone and will remove the ticket from both admin and user views.`, () => {
      this.helpsupportservice.DeleteTicket(ticketId, this.adminid).subscribe((res) => {
        this.getAllOpenTickets();
        this.toaster.success('Ticket deleted successfully');
      }, (error) => {
        console.error('Error deleting ticket:', error);
      });
    }, '/assets/confirmation-msg/deleteTicket.png');
  } 

  getChatHistory(ticket: TicketsDetails) {
     
    this.showEmojiPicker = false;
    this.chatservice.JoinTicketChat(this.adminid);
    this.chatservice.messageReceived$.subscribe(msg => {
      this.TicketChatHistory.push(msg);
    });
    this.SelectedTicket = ticket; 
    this.TouristProfilePhotoUrl=this.SelectedTicket?.profilePhotoUrl
    this.helpsupportservice.getChatHistory(ticket.ticketActivityId).subscribe((res) => {
      this.TicketChatHistory = res;

    }, (error) => {
      console.error('Error fetching chat history:', error);
    });
  }

  getAvatarUrl(roleId: number): string {
  if (roleId === 1) return this.AdminProfilePhotoUrl; 
  return this.TouristProfilePhotoUrl; 
}

sendMessage() {
   

    if (this.MessageToSend.trim()) {
       
      if(this.SelectedTicket)
      this.chatservice.SendTicketMessage(this.adminid, this.SelectedTicket?.ticketActivityId, this.MessageToSend,this.SelectedTicket?.raisedByUserId );
 this.TicketChatHistory.push({
        messageId: 0,
        ticketActivityId: this.SelectedTicket?.ticketActivityId || 0,   
        senderUserId: this.adminid,
        reciversUserId: this.SelectedTicket?.raisedByUserId || 0, 
        messageText: this.MessageToSend,
        sentAt: new Date().toISOString(), 
        isSeen: false,
        seenAt: null, 
        isDeleted: false,
        roleId: 1
      });
      this.MessageToSend = '';
    }
    this.showEmojiPicker = false;
    this.scrollToBottom(); 
  }
showEmojiPicker = false;

  toggleEmojiPicker() {
    this.showEmojiPicker = !this.showEmojiPicker;
  }

  addEmoji(event: EmojiEvent) {
    this.MessageToSend += event.emoji.native;
  }



}
